// extracted by mini-css-extract-plugin
module.exports = {"red4":"#d73027","red3":"#f46d43","red2":"#fdae61","red1":"#fee08b","green1":"#d9ef8b","green2":"#a6d96a","green3":"#66bd63","green4":"#1a9850"};